<template>
  <div class="loader-wrapper">
    <div class="loader">
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
// from: https://loading.io/css/
export default {
  name: "Spinner"
};
</script>

<style lang="scss" scoped>
.loader-wrapper {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: grid;
  place-items: center;
}
.loader {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.loader div {
  position: absolute;
  border: 4px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: loader 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.loader div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes loader {
  0% {
    top: 36px;
    left: 36px;
    width: 1px;
    height: 1px;
    opacity: 1;
  }
  100% {
    top: 1px;
    left: 1px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}
</style>
